module.exports = __webpack_public_path__ + "static/thumbnail-23370b9e22dc127e070d2bca11a41b4e.png";